export default "__VITE_ASSET__dNNyAyFc__"